import { InputLabel } from "@mui/material";
import { FormLabelProps } from "./FormInput.types";

export function FormLabel({ label = "Label", error = false, required = false }: FormLabelProps) {
  return (
    <InputLabel
      error={error}
      sx={{
        textAlign: "left",
        fontSize: "0.875rem",
        fontWeight: "bold",
        lineHeight: "1.0625rem",
        mb: "0.625rem",
      }}
    >
      {label} {required && <span style={{ color: "red" }}>*</span>}
    </InputLabel>
  );
}
